.autocomplete-list {
  display: none;
  position: absolute;
  top:38px;
  z-index: 1000;
  background: white;
  width: 100%;
  border: 1px solid #ccc;
  border-top: none;
  max-height: 200px;
  overflow-y: auto;
}
.autocomplete-item {
  padding: 10px;
  cursor: pointer;
  border-bottom: 1px solid #ddd;
}
.autocomplete-item:hover {
  background: #f0f0f0;
}